<template>
  <div id="navi">
    <nav class="global-nav">
      <ul class="global-nav-list">
        <li class="global-nav-list-item">
          <router-link to="/">トップ</router-link>
        </li>
        <li class="global-nav-list-item">
          <router-link to="/information">お知らせ</router-link>
        </li>
        <li
          class="global-nav-list-item"
          v-if="isPermission('OwnedNonResident')"
        >
          <router-link to="/meeting">総会</router-link>
        </li>
        <li class="global-nav-list-item" v-if="isPermission('Director')">
          <router-link to="/boardofdirectors">理事会</router-link>
        </li>
        <li class="global-nav-list-item">
          <router-link to="/archive">マンション書庫</router-link>
        </li>
        <!-- <li class="global-nav-list-item">
          <router-link to="/documents">規約・届出書類</router-link>
        </li> -->
        <li class="global-nav-list-item" v-if="isPermission('Admin') && false">
          <router-link to="/admin/user">ユーザ管理</router-link>
        </li>
        <!-- <li class="global-nav-list-item">
          <router-link to="/mypage">マイページ</router-link>
        </li> -->
        <!-- <li class="global-nav-list-item">
          <a @click="$emit('logout')">ログアウト</a>
        </li> -->
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "GlobalNavi",
  methods: {
    // eslint-disable-next-line
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
      this.$router.push({ path: key });
    },
    logOut() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
  },
};
</script>

<style></style>
